import React, { useEffect } from 'react';
import { Flex, Typography } from 'antd';
import cp from './ContactsPage.module.scss';
import WithMainContainer from '@/components/layout';
import logo from '/public/static/images/image_logo_full.svg';
import Head from 'next/head';
import { useStores } from '@/utils/hooks/useStores';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
import HeadService from '@/utils/services/HeadService';

function ContactsPage() {
    const {
        systemStore: { setBreadcrumbs },
    } = useStores();
    const LOCALIZATION = useLocalization();
    useEffect(() => {
        setBreadcrumbs([
            {
                key: '/',
                title: LOCALIZATION.routes.home,
            },
            {
                key: '/contacts',
                title: LOCALIZATION.routes.contacts,
            },
        ]);
    }, [LOCALIZATION]);

    return (
        <>
            {process.env.NEXT_PUBLIC_INCLUDE_SEO_TAGS === 'true' &&
                HeadService.simpleBuild('Контакты для связи с TKMP.Istok', '/contacts')}
            <Flex className={cp.container}>
                <Flex className={cp.container_body}>
                    <Flex
                        align={'flex-start'}
                        style={{ width: '100%' }}
                    >
                        <Typography.Text className={`text-24-500`}>
                            {LOCALIZATION.routes.contacts}
                        </Typography.Text>
                    </Flex>
                </Flex>
            </Flex>
        </>
    );
}

export default WithMainContainer(ContactsPage);
